var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
  'button',
  'button--' + _vm.theme,
  'button--' + _vm.shape
]},[_c('span',{staticClass:"slot",class:[
      'slot',
      'slot--' + _vm.arrow,
      'slot--' + _vm.shape
    ]},[_vm._t("default")],2),_vm._v(" "),_c('svg',{class:[
      'arrow',
      'arrow--' + _vm.arrow,
      'arrow--' + _vm.shape
    ],attrs:{"viewBox":"0 0 11.73 15.88","width":"8.55","height":"11.58"}},[_c('path',{attrs:{"d":"M0 15.88V0l11.73 7.94L0 15.88z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e36143c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Button.vue
// module id = null
// module chunks = 